import { Link } from "@tanstack/react-router";
import type { CategoryDisplayInfo } from "../data/category-display";
import { getReadinessColor, getReadinessDotColor } from "../data/category-display";

export function CategoryCard({
  category,
  brand,
}: {
  category: CategoryDisplayInfo;
  brand: string;
}) {
  const Icon = category.icon;
  return (
    <Link
      to="/$brand/$cat"
      params={{ brand, cat: category.slug }}
      className="group flex flex-col items-start gap-3 rounded-xl border border-brand-teal/20 bg-white p-5 shadow-sm transition-all hover:border-brand-teal/40 hover:shadow-md focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring"
      aria-label={`${category.label} – ${category.readiness}% ready`}
    >
      <div className="flex w-full items-center justify-between">
        <div className="rounded-lg bg-accent-light p-2 text-accent transition-colors group-hover:bg-secondary">
          <Icon className="h-5 w-5" />
        </div>
        <div className="flex items-center gap-1.5">
          <span className={`h-2 w-2 rounded-full ${getReadinessDotColor(category.readiness)}`} />
          <span className={`text-xs font-medium ${getReadinessColor(category.readiness)}`}>
            {category.readiness}%
          </span>
        </div>
      </div>
      <div>
        <h3 className="font-semibold text-text-primary">{category.label}</h3>
        <p className="mt-0.5 text-sm text-text-secondary">{category.tagline}</p>
      </div>
    </Link>
  );
}
